import { getCurrentMerchant } from '@/helpers/WorkspaceHelper';

/** 「Member Cash」的商户。 */
export const MEMBER_CASH_MERCHANT_IDS = ['gong-cha-australia-pty--ltd'];

export const isMemberCashMerchant = (merchantId) =>
	MEMBER_CASH_MERCHANT_IDS.includes((merchantId ?? '').toLowerCase());

/**
 * 解析 namespace / key。
 * 侧边栏等使用 t('menu:loyalty.overview.deposit') 时，postProcessor 的 options.ns 为空，
 * namespace 在 key 里（形如 menu:xxx），需要拆出来。
 */
const resolveNsAndKey = (ns, key) => {
	let namespace = Array.isArray(ns) ? ns[0] : ns;
	let k = Array.isArray(key) ? key.join('.') : String(key || '');

	// useTranslation() 会把 options.ns 固定成 defaultNS（如 general），
	// 但 t('reservation:settings.deposit.rules') 的真实 namespace 在 key 前缀里，必须优先用它。
	if (k.includes(':')) {
		const idx = k.indexOf(':');
		namespace = k.slice(0, idx);
		k = k.slice(idx + 1);
	}

	return { namespace, k };
};

/**
 * 预订押金与会员储值无关，reservation 相关 key 一律不改。
 * 例如 menu:reservation.settings.deposit、reservation:deposit 等。
 */
const shouldOverrideKey = (ns, key) => {
	const { namespace, k } = resolveNsAndKey(ns, key);

	if (!k) return false;
	if (namespace === 'reservation') {
		return false;
	}
	if (k.startsWith('reservation.') || k.includes('.reservation.')) {
		return false;
	}
	return /deposit/i.test(k);
};

/**
 * Deposit → Member Cash，deposit → member cash（保留原大小写形式）。
 * 不含英文 deposit 的文案（如「储值」）保持不变。
 */
export const replaceDepositWithMemberCash = (value) => {
	if (typeof value !== 'string' || !/deposit/i.test(value)) return value;
	return value
		.replace(/Deposit/g, 'Member Cash')
		.replace(/deposit/g, 'member cash');
};

export const shouldApplyMemberCashDepositLabel = (ns, key) => {
	const merchant = getCurrentMerchant();
	if (!isMemberCashMerchant(merchant?.merchantId)) return false;
	return shouldOverrideKey(ns, key);
};

const memberCashDepositPostProcessor = {
	name: 'memberCashDeposit',
	type: 'postProcessor',
	process(value, key, options) {
		const ns = options?.ns;
		if (!shouldApplyMemberCashDepositLabel(ns, key)) {
			return value;
		}
		return replaceDepositWithMemberCash(value);
	},
};

export default memberCashDepositPostProcessor;
